<template>
    <v-data-table
        :headers="headers"
        :items="list"
        dense
        :options="options"
        @update:options="updateOptions"
        :footer-props="footer"
        :server-items-length="length"
        :loading="loading"
        disable-sort
    >
        <template v-slot:[`item.code`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.supplier.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.code}}
        </template>

    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "SupplierList",
    data() {
        return {
            headers: [
                { text: "Code", value: "code" },
                { text: "Name", value: "name" },
                { text: "Group", value: "group" },
                { text: "Phone", value: "phone" },
            ],
            footer: {
                'items-per-page-options': [10, 25, 50]
            },
            perm: permissions
        }
    },
    computed : {
        ...mapGetters({
            list: "purchase/supplier/list/data",
            options: "purchase/supplier/list/options",
            loading: "purchase/supplier/list/loading",
            length: "purchase/supplier/list/length",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "purchase/supplier/list/updateOptions"
        }),
        handleClickRow(item){  
            this.$router.push({ name: 'SupplierDisplay', params: { id: item.id}})
        }
    }
}
</script>

<style>

</style>